// extracted by mini-css-extract-plugin
module.exports = {"container":"ApplicationValidationDetails_container__C3bww","description":"ApplicationValidationDetails_description__tt5R4"};